import { ReactNode, useMemo, createContext } from 'react';
import {
  DatasetDataApiRequestData,
  FormApiMethodsRequestData,
  LayoutApiRequestData,
  SubsetDataApiRequestData,
} from '../api/types/types';

// Union of all request data shapes used as JSONata resolving input
export type RequestDataValue =
  | FormApiMethodsRequestData
  | SubsetDataApiRequestData
  | DatasetDataApiRequestData
  | LayoutApiRequestData;

export interface RequestDataContextType {
  isProvided: boolean;
  requestData: RequestDataValue | undefined;
}

const defaultValues: RequestDataContextType = {
  isProvided: false,
  requestData: undefined,
};

// Scoped provider of request data used to resolve apiMethod templates in descendants
export const RequestDataContext =
  createContext<RequestDataContextType>(defaultValues);

interface RequestDataProviderProps {
  children: ReactNode;
  requestData: RequestDataValue | undefined;
}

const RequestDataProvider = ({
  children,
  requestData,
}: RequestDataProviderProps) => {
  const value = useMemo(
    () => ({ isProvided: true, requestData }),
    [requestData]
  );
  return (
    <RequestDataContext.Provider value={value}>
      {children}
    </RequestDataContext.Provider>
  );
};

export default RequestDataProvider;
